import React from "react";
import { Redirect } from "react-router-dom";
import { AccountRole, useMeQuery } from "../../graphql";
import { useAuthToken } from "../../hooks";

export const Private: React.FC<{ roles?: AccountRole[]; children: any }> = ({
    children,
    roles
}) => {
    const { token, role } = useAuthToken();

    if (roles.length === 0) {
        if (!token) {
            return <Redirect to="/login" />;
        } else {
            return children;
        }
    } else {
        if (!token) {
            return <Redirect to="/login" />;
        } else {
            if (roles.includes(role)) {
                return children;
            } else {
                return <Redirect to="/home" />;
            }
        }
    }
};
